<script lang="ts">
	import type { SuperValidated, Infer } from "sveltekit-superforms";
	import { superForm } from "sveltekit-superforms/client";
	import SuperDebug from "sveltekit-superforms";
	import { Button } from "@repo/ui/components/ui/button";
	import { Input } from "@repo/ui/components/ui/input";
	import { Label } from "@repo/ui/components/ui/label";
	import { Textarea } from "@repo/ui/components/ui/textarea";
	import type { ContactFormSchema } from "./formSchema";
	import { toast } from "svelte-sonner";
	import { dev } from "$app/environment";
	import { Turnstile } from "@repo/ui/components/ui/turnstile";
	import { PUBLIC_TURNSTILE_SITE_KEY } from "$env/static/public";

	let {
		data,
		address,
		onSuccess,
	}: { data: SuperValidated<Infer<ContactFormSchema>>; address: string; onSuccess?: () => void } =
		$props();

	const { form, errors, enhance, delayed } = superForm(data, {
		warnings: {
			duplicateId: false,
		},
		onResult: ({ result }) => {
			if (result.status === 200) {
				onSuccess?.();
				toast.success("Message Sent");
			}
		},
	});

	$form.property = address;
</script>

<form method="POST" action="?/submitContactForm" use:enhance class="flex flex-col gap-2">
	<input type="hidden" id="property" name="property" bind:value={$form.property} />
	<div class="space-y-1">
		<Label for="name">Name</Label>
		<Input name="name" bind:value={$form.name} class="shadow" />
		{#if $errors.name}
			<p class="text-sm text-red-500">{$errors.name}</p>
		{/if}
	</div>

	<div class="space-y-1">
		<Label for="email">Email</Label>
		<Input name="email" type="email" bind:value={$form.email} class="shadow" />
		{#if $errors.email}
			<p class="text-sm text-red-500">{$errors.email}</p>
		{/if}
	</div>

	<div class="space-y-1">
		<Label for="phone">Phone</Label>
		<Input name="phone" type="tel" bind:value={$form.phone} class="shadow" />
		{#if $errors.phone}
			<p class="text-sm text-red-500">{$errors.phone}</p>
		{/if}
	</div>

	<div class="space-y-1">
		<Label for="message">Message</Label>
		<Textarea name="message" bind:value={$form.message} class="shadow" />
		{#if $errors.message}
			<p class="text-sm text-red-500">{$errors.message}</p>
		{/if}
	</div>

	<div class="mt-4 space-y-4">
		<Turnstile
			siteKey={PUBLIC_TURNSTILE_SITE_KEY}
			onCallback={(token) => {
				$form.turnstileToken = token;
			}}
		/>
		<Button type="submit" class="w-full" disabled={$delayed}>
			{$delayed ? "Sending..." : "Send Message"}
		</Button>
		{#if dev}
			<SuperDebug data={$form} />
		{/if}
	</div>
</form>
